(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@scuf/common"), require("react"));
	else if(typeof define === 'function' && define.amd)
		define("@PremiumCommercial/PremiumCommercial.pc.digitalsignage.remote", ["@scuf/common", "react"], factory);
	else if(typeof exports === 'object')
		exports["@PremiumCommercial/PremiumCommercial.pc.digitalsignage.remote"] = factory(require("@scuf/common"), require("react"));
	else
		root["@PremiumCommercial/PremiumCommercial.pc.digitalsignage.remote"] = factory(root["@scuf/common"], root["react"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__911__, __WEBPACK_EXTERNAL_MODULE__155__) => {
return 